"use client";

import { useTranslation } from "@/hooks/useLanguage";
export const Statistics = () => {
  const { t } = useTranslation();
  const stats = t("about.statistics.statistics_list");

  // Ensure stats is always an array to prevent runtime errors
  const safeStats = Array.isArray(stats) ? stats : [];

  return (
    <section id="statistics">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
        {safeStats.map(({ quantity, description }) => (
          <div key={description} className="space-y-2 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold">{quantity}</h2>
            <p className="text-xl text-muted-foreground">{description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
